import { cn } from '@woonstad/helpers-utils';
import React from 'react';

import { Typography, Variant } from '../typography/Typography';

type LabelValueProps = {
  title?: string;
  data?: Array<{
    label: string;
    value?: number | string | React.ReactElement | null;
    testid?: string;
  }>
  direction?: 'column' | 'row',
  columnCount?: 1 | 2,
}

export const LabelValue = ({
  title,
  data,
  direction = 'column',
  columnCount = 1,
}: LabelValueProps) => {

  // When 2 columns split data into two arrays
  const data1 = data?.slice(0, Math.ceil(data.length / 2));
  const data2 = data?.slice(Math.ceil(data.length / 2), data.length);

  return (
    <dl className="space-y-4">
      {title ? (
        <dt>
          <Typography
            variant="label-regular"
            textColorClassname="text-label-enabled"
          >
            {title}
          </Typography>
        </dt>
      ) : null}
      {columnCount === 1 ? (
        <dd className={cn('grid grid-cols-1 gap-2')}>
          {data?.map((item) => {
            if (!item.value) return null;

            return (
              <dl
                key={item.testid || `${item.label}-${item.value}`}
                className={cn(direction === 'column' ? 'flex flex-col' : 'grid grid-cols-2')}
              >
                <dt>
                  <Typography
                    variant={cn(direction === 'column' ? 'label-small' : 'content-body') as Variant}
                    textColorClassname="text-label-value-label"
                    data-testid={`${item.testid}Label`}
                  >
                    {item.label}
                  </Typography>
                </dt>
                <dd>
                  {/* Only render typography element when it's a string or number */}
                  {item.value && (typeof item.value === 'string' || typeof item.value === 'number') ? (
                    <Typography
                      variant="label-regular"
                      textColorClassname="text-label-value-value"
                      data-testid={`${item.testid}Value`}
                    >
                      {item.value}
                    </Typography>
                    /* Only render component when it's not a string or number */
                  ) : item.value}
                </dd>
              </dl>
            );
          })}
        </dd>
      ) : (
        <dd className="grid grid-cols-1 md:flex">
          <div className="space-y-2 pb-2 md:w-1/2 md:pb-0">
            {data1?.map((item) => {
              if (!item.value) return null;

              return (
                <dl
                  key={item.testid || `${item.label}-${item.value}`}
                  className={cn(direction === 'column' ? 'flex flex-col' : 'grid grid-cols-2 ')}
                >
                  <dt>
                    <Typography
                      variant={cn(direction === 'column' ? 'label-small' : 'content-body') as Variant}
                      textColorClassname="text-label-value-label"
                      data-testid={`${item.testid}Label`}
                    >
                      {item.label}
                    </Typography>
                  </dt>
                  <dd>
                    <Typography
                      variant="label-regular"
                      textColorClassname="text-label-value-value"
                      data-testid={`${item.testid}Value`}
                    >
                      {item.value}
                    </Typography>
                  </dd>
                </dl>
              );
            })}
          </div>
          <div className="space-y-2 md:w-1/2">
            {data2?.map((item) => {
              if (!item.value) return null;

              return (
                <dl
                  key={item.testid || `${item.label}-${item.value}`}
                  className={cn(direction === 'column' ? 'flex flex-col' : 'grid grid-cols-2 ')}
                >
                  <dt>
                    <Typography
                      variant={cn(direction === 'column' ? 'label-small' : 'content-body') as Variant}
                      textColorClassname="text-label-value-label"
                      data-testid={`${item.testid}Label`}
                    >
                      {item.label}
                    </Typography>
                  </dt>
                  <dd>
                    <Typography
                      variant="label-regular"
                      textColorClassname="text-label-value-value"
                      data-testid={`${item.testid}Value`}
                    >
                      {item.value}
                    </Typography>
                  </dd>
                </dl>
              );
            })}
          </div>
        </dd>
      )}
    </dl>
  );
};
